// extracted by mini-css-extract-plugin
export default {"page":"StatisticsPage_page__HaGKb","flexBox":"StatisticsPage_flexBox__ZNFNY"};